import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=ac6b229a"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac6b229a')) {
      api.createRecord('ac6b229a', component.options)
    } else {
      api.reload('ac6b229a', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=ac6b229a", function () {
      api.rerender('ac6b229a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/reset.vue"
export default component.exports